import React, { useState, useEffect, useContext, useRef } from "react";
// import quizThumb from '../../assets/images/quiz-default.jpg';
import Footer from "../../components/footer/Footer";
import SideMenu from "./../student/SideMenu";
import Header from "../../components/dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../../components/loader";
import OpenSeadragon from "openseadragon";
import deepZoom from "../../assets/images/icons/Dna-dz.svg"
import Editor from 'react-simple-wysiwyg';

const AddSummary = ({ }) => {

    let { id } = useParams();
    const location = useLocation();
    const moduleType = location.state?.moduleType;

    const transformRef = useRef(null);
    const viewerRef = useRef(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [qdisplay, setQdisplay] = useState(false);
    const [imageCloudfront, setImg] = useState("");
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState("");
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [img, setImage] = useState("");
    const [popup, setPopup] = useState(false)
    const [casesList, setCasesList] = useState([]);       // final merged list
    const [loader, setLoader] = useState(false);

    const handleClosePopup = () => { setActiveFeedbackModal(false); setFeedBackData({}) };

    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);

    // const [isLoading, setIsLoading] = useState(true);

    const [learninguniqueid, setLearninguniqueid] = useState(null);
    const [selected, setSelected] = useState({});
    const [successMsg, setSuccessMsg] = useState(false)
    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [viewer, setViewer] = useState(null);

    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");
    const [dzipopupImage, setDZIPopupImage] = useState(false);

    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [ActiveCaseId, setActiveCaseId] = useState("");
    const [saveMessage, setSaveMessage] = useState('');

    const [showImagePopup, setShowImagePopup] = useState(false);
    const [activeFeedbackModal, setActiveFeedbackModal] = useState(false);
    const [popupPngImage, setPopupPngImage] = useState("");
    const [feedbackText, setFeedbackText] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [feedbackLoading, setFeedbackLoading] = useState(false); // NEW

    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [feedBackData, setFeedBackData] = useState({});
    const [quizResultData, setQuizResultData] = useState([]);
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)

    const MAX_MARKS = 100;

    // State to store all case data (summary and marks for each case)
    const [casesData, setCasesData] = useState({});
    const [errors, setErrors] = useState({});
    const [isSaved, setIsSaved] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        console.log("casesData updated:", casesData);
    }, [casesData]); 

    useEffect(() => {
        console.log("errors updated:", errors);
    }, [errors]);

    useEffect(() => {
        console.log("isSaved updated:", isSaved);
    }, [isSaved]);

    useEffect(() => {
        console.log("isSubmitting updated:", isSubmitting);
    }, [isSubmitting]);

    // Add this function near the top of your component
    const stripHtmlTags = (html) => {
        if (!html) return '';
        // Create a temporary div to parse HTML and get text content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    };


    // Initialize casesData when quizResultData loads
    // useEffect(() => {
    //     if (quizResultData?.cases) {
    //         const initialData = {};
    //         quizResultData.cases.forEach((caseItem) => {
    //             initialData[caseItem.caseid] = {
    //                 summary: '',
    //                 marks: '',
    //                 caseid: caseItem.caseid
    //             };
    //         });
    //         setCasesData(initialData);
    //     }
    // }, [quizResultData]);


    // HTML entity decoder utility
    const decodeHtmlEntities = (text) => {
        if (!text) return '';

        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    };

    // HTML entity encoder utility
    const encodeHtmlEntities = (text) => {
        if (!text) return '';

        return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    // useEffect(() => {
    //     if (quizResultData?.cases) {
    //         const initialData = {};
    //         quizResultData.cases.forEach((caseItem) => {
    //             initialData[caseItem.caseid] = {
    //                 summary: caseItem?.caseDetails?.explanation || '', // Populate from API if exists
    //                 marks: caseItem.marks !== undefined && caseItem.marks !== null ? caseItem.marks.toString() : '', // Populate from API if exists
    //                 caseid: caseItem.caseid
    //             };
    //         });
    //         setCasesData(initialData);
    //     }
    // }, [quizResultData]);
    useEffect(() => {
    if (quizResultData?.cases) {
        console.log("Debug - Full quizResultData:", quizResultData);
        
        // Log each case to see the structure
        quizResultData.cases.forEach((caseItem, index) => {
            console.log(`Case ${index + 1} (${caseItem.caseid}):`, {
                summary: caseItem?.summary,
                marks: caseItem?.marks,
                caseDetails: caseItem?.caseDetails,
                explanation: caseItem?.caseDetails?.explanation
            });
        });
        
        const initialData = {};
        quizResultData.cases.forEach((caseItem) => {
            // Get summary from the correct location
            const summary = caseItem?.summary || caseItem?.caseDetails?.explanation || '';
            const decodedSummary = decodeHtmlEntities(summary);

            initialData[caseItem.caseid] = {
                summary: decodedSummary,
                marks: caseItem.marks !== undefined && caseItem.marks !== null ? caseItem.marks.toString() : '',
                caseid: caseItem.caseid
            };
        });
        setCasesData(initialData);
        console.log("Initialized casesData:", initialData);
    }
}, [quizResultData]);

    console.log('aaaaaaaaaaaaaaaaaa', quizResultData);

    const validateMarks = (value) => {
        if (!value) {
            return 'Marks are required';
        }
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
            return 'Please enter a valid number';
        }
        if (numValue < 0) {
            return 'Marks cannot be negative';
        }
        if (numValue > MAX_MARKS) {
            return `Marks cannot exceed ${MAX_MARKS}`;
        }
        return '';
    };

    const validateSummary = (value) => {
        if (!value.trim()) {
            return 'Case summary is required';
        }
        if (value.trim().length < 10) {
            return 'Summary must be at least 10 characters';
        }
        return '';
    };

    // const handleSummaryChange = (caseid, value) => {


    // console.log("Value:", value);
    //     setCasesData(prev => ({
    //         ...prev,
    //         [caseid]: {
    //             ...prev[caseid],
    //             summary: value
    //         }
    //     }));

    //     // Clear error when user starts typing
    //     if (errors[`${caseid}_summary`]) {
    //         setErrors(prev => {
    //             const newErrors = { ...prev };
    //             delete newErrors[`${caseid}_summary`];
    //             return newErrors;
    //         });
    //     }
    //     setIsSaved(false);
    // };
    const handleSummaryChange = (caseid, value) => {
        console.log("Updating summary for case:", caseid);
        console.log("New value:", value);

        setCasesData(prev => ({
            ...prev,
            [caseid]: {
                ...prev[caseid],
                summary: value
            }
        }));

        // Clear error when user starts typing
        if (errors[`${caseid}_summary`]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[`${caseid}_summary`];
                return newErrors;
            });
        }
        setIsSaved(false);
    };

    const handleMarksChange = (caseid, value) => {
        // Allow only numbers and decimal point
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
            setCasesData(prev => ({
                ...prev,
                [caseid]: {
                    ...prev[caseid],
                    marks: value
                }
            }));

            // Clear error when user starts typing
            if (errors[`${caseid}_marks`]) {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[`${caseid}_marks`];
                    return newErrors;
                });
            }
            setIsSaved(false);
        }
    };

    const handleSubmit1 = async () => {
        // Validate all cases
        const newErrors = {};
        let hasErrors = false;

        Object.keys(casesData).forEach(caseid => {
            const summaryError = validateSummary(casesData[caseid].summary);
            const marksError = validateMarks(casesData[caseid].marks);

            if (summaryError) {
                newErrors[`${caseid}_summary`] = summaryError;
                hasErrors = true;
            }
            if (marksError) {
                newErrors[`${caseid}_marks`] = marksError;
                hasErrors = true;
            }
        });

        if (hasErrors) {
            setErrors(newErrors);
            // Scroll to first error
            const firstErrorElement = document.querySelector('.border-danger');
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }

        // Prepare payload
        const payload = Object.keys(casesData).map(caseid => ({
            caseid: caseid,
            summary: casesData[caseid].summary,
            marks: parseFloat(casesData[caseid].marks),
        }));

        setIsSubmitting(true);




        // setLoading(true);
        try {

            const response = await tmdbApi.updatePathologySummaryApi(state?.fellowuserid, state?.learninguniqueid, payload);

            console.log('response------>', response)
            // const result = await response.json();
            // "case summaries updated successfully"

            // console.log('Submit successful:', result);

            setIsSaved(true);

            // Clear saved message after 3 seconds
            setTimeout(() => {
                setIsSaved(false);
            }, 3000);
        } catch (err) {
            console.error('Error submitting data:', err);
            alert('Failed to submit. Please try again.');
        } finally {
            setIsSubmitting(false);
        }

    };

    const handleReset = () => {
        if (window.confirm('Are you sure you want to reset all case summaries and marks?')) {
            const resetData = {};
            Object.keys(casesData).forEach(caseid => {
                resetData[caseid] = {
                    summary: '',
                    marks: '',
                    caseid: caseid
                };
            });
            setCasesData(resetData);
            setErrors({});
            setIsSaved(false);
        }
    };



    // Calculate Module Score (Percentage)
    const calculateModuleScore = () => {
        let totalMarks = 0;
        let caseCount = 0;

        Object.keys(casesData).forEach(caseid => {
            const marks = parseFloat(casesData[caseid].marks);
            if (!isNaN(marks)) {
                totalMarks += marks;
                caseCount++;
            }
        });

        if (caseCount === 0) return 0;

        // Calculate percentage: (totalMarks / (caseCount × 100)) × 100
        const moduleScore = (totalMarks / (caseCount * MAX_MARKS)) * 100;
        return parseFloat(moduleScore.toFixed(2)); // Round to 2 decimal places
    };

    // Handle Save (Draft Mode - No Validation)
    // const handleSave = async () => {
    //     // Prepare payload with only filled data
    //     const payload = Object.keys(casesData)
    //         .filter(caseid => {
    //             // Include cases that have either marks or summary filled
    //             return casesData[caseid].marks !== '' || casesData[caseid].summary.trim() !== '';
    //         })
    //         .map(caseid => ({
    //             caseid: caseid,
    //             summary: casesData[caseid].summary,
    //             marks: casesData[caseid].marks !== '' ? parseFloat(casesData[caseid].marks) : null,
    //         }));

    //     // Calculate module score based on filled marks only
    //     const moduleScore = calculateModuleScore();

    //     const requestBody = {
    //         cases: payload,
    //         moduleScore: moduleScore,
    //         pathologistSubmitted: false
    //     };

    //     setIsSubmitting(true);

    //     try {
    //         const response = await tmdbApi.updatePathologySummaryApi(
    //             state?.fellowuserid,
    //             state?.learninguniqueid,
    //             requestBody
    //         );

    //         console.log('Save successful:', response);



    //         setIsSaved(true);
    //         setSaveMessage('Draft saved successfully!');
    //         GetQuizResult();
    //         // Clear saved message after 3 seconds
    //         setTimeout(() => {
    //             setIsSaved(false);
    //             GetQuizResult()
    //             setSaveMessage('');
    //         }, 3000);
    //     } catch (err) {
    //         console.error('Error saving data:', err);
    //         alert('Failed to save. Please try again.');
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };



    const handleSave = async () => {
        // First, validate all cases
        const newErrors = {};
        let hasContent = false;

        Object.keys(casesData).forEach(caseid => {
            const summary = casesData[caseid].summary || '';
            const plainText = stripHtmlTags(summary);

            if (plainText.trim()) {
                hasContent = true;
            }

            if (!plainText.trim()) {
                newErrors[`${caseid}_summary`] = 'Explanation is required';
            } else if (plainText.trim().length < 10) {
                newErrors[`${caseid}_summary`] = 'Explanation must be at least 10 characters';
            }
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        if (!hasContent) {
            alert('Please add explanation for at least one case');
            return;
        }

        setIsSubmitting(true);

        try {
            const payload = Object.keys(casesData)
                .filter(caseid => {
                    const summary = casesData[caseid].summary || '';
                    const marks = casesData[caseid].marks || '';
                    return summary.trim() !== '' || marks !== '';
                })
                .map(caseid => ({
                    caseid: caseid,
                    summary: casesData[caseid].summary,
                    marks: casesData[caseid].marks !== '' ? parseFloat(casesData[caseid].marks) : null,
                }));

            const moduleScore = calculateModuleScore();

            const requestBody = {
                cases: payload,
                moduleScore: moduleScore,
                pathologistSubmitted: false
            };

            console.log('Saving all data:', requestBody);

            const response = await tmdbApi.updatePathologySummaryApi(
                state?.fellowuserid,
                state?.learninguniqueid,
                requestBody
            );

            console.log('Save successful:', response);

            // Count how many cases were saved
            const savedCount = payload.length;
            const totalCases = Object.keys(casesData).length;

            // Get a preview of the first case's content
            const firstCaseId = Object.keys(casesData)[0];
            const firstCaseContent = casesData[firstCaseId]?.summary || '';
            const previewText = stripHtmlTags(firstCaseContent).substring(0, 30);

           setSaveMessage('Saved successfully');

            setIsSaved(true);

            // Refresh data
            GetQuizResult();

            setTimeout(() => {
                setIsSaved(false);
                setSaveMessage('');
            }, 5000);
        } catch (err) {
            console.error('Error saving all data:', err);
            setSaveMessage('Error: Failed to save data');

            setTimeout(() => {
                setSaveMessage('');
            }, 3000);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Debug log to see current state
    useEffect(() => {
        console.log("Current casesData state:", casesData);
    }, [casesData]);

    // Log when quizResultData changes
    useEffect(() => {
        if (quizResultData?.cases) {
            quizResultData.cases.forEach((caseItem, index) => {
                console.log(`Case ${index + 1} explanation from API:`, caseItem?.caseDetails?.explanation);
                console.log(`Case ${index + 1} decoded explanation:`, decodeHtmlEntities(caseItem?.caseDetails?.explanation || ''));
            });
        }
    }, [quizResultData]);

    // Handle Submit (Final Submission - With Validation)
    const handleSubmit = async () => {
        // Validate all cases
        const newErrors = {};
        let hasErrors = false;

        Object.keys(casesData).forEach(caseid => {
            const summaryError = validateSummary(casesData[caseid].summary);
            const marksError = validateMarks(casesData[caseid].marks);

            if (summaryError) {
                newErrors[`${caseid}_summary`] = summaryError;
                hasErrors = true;
            }
            if (marksError) {
                newErrors[`${caseid}_marks`] = marksError;
                hasErrors = true;
            }
        });

        if (hasErrors) {
            setErrors(newErrors);
            // Scroll to first error
            const firstErrorElement = document.querySelector('.border-danger');
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }

        // Prepare payload with all cases
        const payload = Object.keys(casesData).map(caseid => ({
            caseid: caseid,
            summary: casesData[caseid].summary,
            marks: parseFloat(casesData[caseid].marks),
        }));

        // Calculate module score
        const moduleScore = calculateModuleScore();

        const requestBody = {
            cases: payload,
            moduleScore: moduleScore,
            pathologistSubmitted: true
        };

        setIsSubmitting(true);

        try {
            const response = await tmdbApi.updatePathologySummaryApi(
                state?.fellowuserid,
                state?.learninguniqueid,
                requestBody
            );

            console.log('Submit successful:', response);

            setIsSaved(true);
            setSaveMessage('All cases submitted successfully!');

            // Clear saved message after 3 seconds
            setTimeout(() => {
                setIsSaved(false);
                setSaveMessage('');
            }, 3000);
        } catch (err) {
            console.error('Error submitting data:', err);
            alert('Failed to submit. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };


    const handleFeedbackChange = (e) => {
        setFeedbackText(e.target.value);
        if (errorMsg) setErrorMsg("");
    };


    // ----------------------
    //  SUBMIT HANDLER
    // ----------------------
    const handleFeedbackSubmit = async () => {
        if (!feedbackText.trim()) {
            setErrorMsg("Feedback is required");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                feedbackDescription: feedbackText,
                moduleid: id,
                caseid: ActiveCaseId,
            };

            const isUpdate = feedBackData && feedBackData._id;
            const res = await tmdbApi.addFeedback(payload, isUpdate);

            // success reset
            setFeedbackText("");
            setErrorMsg("");
            setActiveCaseId("");
            handleClosePopup();
        } catch (err) {
            console.error("Error submitting feedback:", err.response?.data || err.message);
            setErrorMsg("Failed to submit. Try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity
        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };
        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });

        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);


    useEffect(() => {
        GetQuizResult();
    }, [])


    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };


    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const handlePopupload = (e) => {
        setPopupLoading(true)
        console.log(dziUrl, "dz")
    }



    const [cancel, setCancel] = useState(false);



    const getFeedbackAPI = async (caseid) => {
        setFeedbackLoading(true);
        try {
            const response = await tmdbApi.getFeedbackApi(caseid, quizResultData?.moduleid, "client");
            if (response?.result) {
                const data = response.result[0] ?? null;
                setFeedBackData(data);
                // setText only after we set the data, to avoid flicker
                setFeedbackText(data?.feedbackDescription ?? "");
            } else {
                setFeedBackData(null);
                setFeedbackText("");
            }
        } catch (err) {
            console.error("getFeedbackAPI error:", err);
            setFeedBackData(null);
            setFeedbackText("");
        } finally {
            setFeedbackLoading(false);
        }
    };

    const GetQuizResult = async () => {
        setLoader(true)
        // console.log('setcontentLoadedsetcontentLoadedsetcontentLoaded', id)
        try {
            const response = await tmdbApi.learningModulePercentile2(id, state?.fellowuserid, state?.learninguniqueid);
            const allCases = response?.result?.[0] || [];



            console.log('all cases', allCases)

            setQuizResultData(allCases);
            


            // setcontentLoaded(true);
        } catch (err) {
            console.log("error", err);
            // setcontentLoaded(true);
        } finally {
            setLoader(false)
        }
    };





    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupPngImage(imageUrl)
    }


    const [videoUrl, setVideoUrl] = useState(null);

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };



    console.log('moduletypeeeeeeeeeeee', moduleType)

    const handleFeedBackPopup = (item) => {
        setActiveCaseId(item.caseid);
        // clear previous data so UI doesn't show stale values while fetching
        setFeedBackData(null);
        setFeedbackText("");
        setActiveFeedbackModal(true);
        getFeedbackAPI(item.caseid);
    };
    useEffect(() => {
        if (feedBackData) {
            // ensure we only update text if not currently fetching (guard)
            if (!feedbackLoading) {
                setFeedbackText(feedBackData.feedbackDescription ?? "");
            }
        }
    }, [feedBackData, feedbackLoading]);
    return (
        <div id="layout-wrapper" className="module-quiz-db">
            <Header />
            <SideMenu />


            <div className="main-content user-management quiz-page" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-start gap-5">
                                    <div className="flex-grow-1 d-grid gap-2">

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => navigate('/submitted-modules/' + state?.fellowuserid)}>
                                        Back
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-between flex-wrap case-main-heading">

                                <div className="col-lg-8 col-md-8 col-12">
                                    <h4 className="mb-2 card-title" id="breadcrumb-title">
                                        {quizResultData?.moduleName}
                                    </h4>
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: quizResultData?.moduledescription }}></p>

                                </div>
                                {videoUrl && <>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <h2 className="quiz-title">Video</h2>

                                        <div className="video-card">
                                            <img src={videoUrl ? `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/0.jpg` : `https://img.youtube.com/vi/0.jpg`} alt="Thumbnail" />
                                            <button className="play-btn" >
                                                <span className="material-symbols-outlined" style={{ cursor: "pointer" }}
                                                    onClick={() => setShowVideoPopup(true)}>
                                                    play_arrow
                                                </span>
                                            </button>
                                        </div>

                                    </div>
                                    <div className="cpcquiz-line1"></div>
                                </>}
                            </div>


                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card bg-transparent shadow-none">
                                    <div className="card-body cpc-management p-0 bg-transparent">

                                        <div className="wrapper client_wrapper mt-3 pt-3">
                                            {/* <div className="quiz_page view-history-page"> */}
                                            <div className="quiz_page">


                                                {/* <div className="question_block quiz-page">


                                                    {
                                                        loader ? <Loader /> :
                                                            quizResultData?.cases && (
                                                                <div className="mb-4">
                                                                    {quizResultData.cases.map((caseItem, qIndex) => {
                                                                        const userAnswer = caseItem.answers.find(ans => ans.hasOwnProperty('isCorrect'));
                                                                        const isCorrectAnswer = userAnswer?.isCorrect === true;
                                                                        return (
                                                                            <div key={qIndex} className="mb-4 case-block">
                                                                                <div className="cpcquiz-ques">
                                                                                    <div className="row justify-content-between align-items-start col-lg-12 quiz-ques-img-case">
                                                                                       
                                                                                        <div className="d-flex flex-column col-lg-8 quiz-ques-sect">
                                                                                            <div className="d-flex justify-content-between gap-1 align-items-start">
                                                                                                <h3 className="quiz-title">Case {qIndex + 1}</h3>
                                                                                            </div>

                                                                                            <div>
                                                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: caseItem?.caseDetails?.clinicalhistory }} />
                                                                                            </div>

                                                                                            <p className="col-lg-12 quiz-para" dangerouslySetInnerHTML={{ __html: caseItem?.clinicalhistory }} />

                                                                                            <div>
                                                                                                <div className="case-answer-section">
                                                                                                    <div className="question_block p-0 mt-0">
                                                                                                        <div className="result_table cpc-fb-sec-table">
                                                                                                            <div>
                                                                                                               
                                                                                                                <div className="row fw-semibold py-1">
                                                                                                                    <div className="col-12 case-answer-heading">
                                                                                                                        ANSWER :
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="row py-2 align-items-center">
                                                                                                                    <div className="col-12">
                                                                                                                        <span className="correct">{userAnswer?.answer}</span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                               
                                                                                                                <div className="row mb-3">
                                                                                                                    <div className="col-lg-6 col-12">
                                                                                                                        <label className="fw-semibold mb-2" style={{ fontSize: '15px', color: '#333' }}>
                                                                                                                            Marks Obtained: <span style={{ color: '#dc3545' }}>*</span>
                                                                                                                        </label>
                                                                                                                        <div style={{ position: 'relative' }}>
                                                                                                                            <input
                                                                                                                                type="text"
                                                                                                                                className={`text-input ${errors.marks ? 'border-danger' : ''}`}
                                                                                                                                placeholder={`Enter marks (Max: ${MAX_MARKS})`}
                                                                                                                                value={marks}
                                                                                                                                onChange={handleMarksChange}
                                                                                                                                style={{
                                                                                                                                    width: "100%",
                                                                                                                                    padding: "10px 12px",
                                                                                                                                    borderRadius: "4px",
                                                                                                                                    fontSize: "14px",
                                                                                                                                    border: errors.marks ? '2px solid #dc3545' : '1px solid #ced4da'
                                                                                                                                }}
                                                                                                                            />
                                                                                                                            <span style={{
                                                                                                                                position: 'absolute',
                                                                                                                                right: '12px',
                                                                                                                                top: '50%',
                                                                                                                                transform: 'translateY(-50%)',
                                                                                                                                fontSize: '14px',
                                                                                                                                color: '#6c757d',
                                                                                                                                fontWeight: '500'
                                                                                                                            }}>
                                                                                                                                / {MAX_MARKS}
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                        {errors.marks && (
                                                                                                                            <small className="text-danger d-block mt-1" style={{ fontSize: '13px' }}>
                                                                                                                                {errors.marks}
                                                                                                                            </small>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                              
                                                                                                                <div className="row">
                                                                                                                    <div className="col-12">
                                                                                                                        <label className="fw-semibold mb-2" style={{ fontSize: '15px', color: '#333' }}>
                                                                                                                            Case Summary: <span style={{ color: '#dc3545' }}>*</span>
                                                                                                                        </label>
                                                                                                                        <textarea
                                                                                                                            className={`text-input module-quiz-textarea ${errors.summary ? 'border-danger' : ''}`}
                                                                                                                            placeholder="Add your case summary (minimum 10 characters)"
                                                                                                                            value={caseSummary}
                                                                                                                            onChange={handleSummaryChange}
                                                                                                                            rows={4}
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                padding: "10px 12px",
                                                                                                                                borderRadius: "4px",
                                                                                                                                fontSize: "14px",
                                                                                                                                resize: "vertical",
                                                                                                                                minHeight: "100px",
                                                                                                                                border: errors.summary ? '2px solid #dc3545' : '1px solid #ced4da'
                                                                                                                            }}
                                                                                                                        />
                                                                                                                        {errors.summary && (
                                                                                                                            <small className="text-danger d-block mt-1" style={{ fontSize: '13px' }}>
                                                                                                                                {errors.summary}
                                                                                                                            </small>
                                                                                                                        )}
                                                                                                                        <small className="text-muted d-block mt-1" style={{ fontSize: '12px' }}>
                                                                                                                            {caseSummary.length} characters
                                                                                                                        </small>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                              
                                                                                                                <div className="row mt-3">
                                                                                                                    <div className="col-12 d-flex align-items-center gap-3">
                                                                                                                        <button
                                                                                                                            onClick={handleSave}
                                                                                                                            className="btn btn-primary"
                                                                                                                            style={{
                                                                                                                                padding: "10px 24px",
                                                                                                                                fontSize: "14px",
                                                                                                                                fontWeight: "500",
                                                                                                                                borderRadius: "4px"
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            Save Case Evaluation
                                                                                                                        </button>

                                                                                                                        {isSaved && (
                                                                                                                            <span className="text-success d-flex align-items-center" style={{ fontSize: '14px', fontWeight: '500' }}>
                                                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                                                                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                                                                                                                </svg>
                                                                                                                                Saved successfully!
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-lg-4 quiz-img-section view-history-img-section">
                                                                                            <div className="quiz-img">



                                                                                            </div>
                                                                                            <div className={caseItem?.caseDetails?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>

                                                                                                <div className="d-grid justify-content-start gap-2 align-items-center">
                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.files && caseItem?.caseDetails?.files.length > 0 && <p className="mt-2">Histological Photos</p>}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper"> {caseItem?.caseDetails?.files?.map((file, fileIndex) => (
                                                                                                            <div key={fileIndex}

                                                                                                                className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                onClick={(e) => {
                                                                                                                    let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                                    let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                   
                                                                                                                    setPopupOpen(true);
                                                                                                                    setImageDimensions({ width: file.width, height: file.height });

                                                                                                                    let path = file.dziUrl || "";
                                                                                                                    if (path.startsWith("/")) path = path.slice(1);
                                                                                                                    let isDziURL = path.includes("output.dzi");
                                                                                                                    if (isDziURL) {
                                                                                                                        path = `${path}_files/`;
                                                                                                                        setDziUrl(imageCloudfront + path);
                                                                                                                    } else {
                                                                                                                        setDziUrl(imagePath);
                                                                                                                    }

                                                                                                                    setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                    setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                    handlePopupload(e);

                                                                                                                }}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                                                <span className="default-img">

                                                                                                                    <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                                        file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                                    )} alt={file?.originalFilename} />

                                                                                                                </span>
                                                                                                            </div>

                                                                                                        ))}</div>

                                                                                                    </div>

                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 &&
                                                                                                            <p>Clinical History Photos</p>}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                            {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 && caseItem?.caseDetails?.historyfiles?.map((file, key) => {

                                                                                                                let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                return (

                                                                                                                    <div
                                                                                                                        key={key}
                                                                                                                        className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                        style={{ width: 'auto' }}
                                                                                                                        onClick={(e) => handlePngPopupImage(imagePath)}
                                                                                                                    >
                                                                                                                        <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                                                                        <img
                                                                                                                            src={`${imageCloudfront}${file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                                            alt={`Image ${key + 1}`}
                                                                                                                            loading="lazy"
                                                                                                                        />
                                                                                                                    </div>


                                                                                                                )
                                                                                                            })}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="cpcquiz-line">
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>

                                                                                    </div>


                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )
                                                    }



                                                   
                                                    <div className="btns quiz-form-btns">
                                                        <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => { }}>Submit</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => { }}>Reset</button>
                                                    </div>
                                                </div> */}
                                                <div className="question_block quiz-page p-0 bg-transparent">
                                                    {loader ? (
                                                        <Loader />
                                                    ) : (
                                                        quizResultData?.cases && (
                                                            <div className="mb-4">
                                                                {quizResultData.cases.map((caseItem, qIndex) => {
                                                                    console.log('casssssssssetie', caseItem?.answers)
                                                                    const userAnswer = caseItem.answers.find(ans => ans.hasOwnProperty('isCorrect'));
                                                                    const currentCaseData = casesData[caseItem.caseid] || { summary: '', marks: '' };
                                                                    // console.log('curerentcase dataaaa',currentCaseData)
                                             

                                                                    return (
                                                                        <div
                                                                            key={qIndex}
                                                                            className="mb-4 case-block admin-case-card"
                                                                        >
                                                                            <div className="cpcquiz-ques">
                                                                                <div className="row justify-content-between align-items-start col-lg-12 quiz-ques-img-case">

                                                                                    {/* LEFT SECTION */}
                                                                                    <div className="d-flex flex-column col-lg-8 quiz-ques-sect">

                                                                                        {/* Case Header */}
                                                                                        <div className="d-flex gap-1 align-items-center mb-2">
                                                                                            <span className="material-symbols-outlined icon-color">
                                                                                                assignment
                                                                                            </span>
                                                                                            <h2 className="mb-0 admin-case-title" style={{ fontSize: "18px" }}>
                                                                                                Case {qIndex + 1}
                                                                                            </h2>
                                                                                        </div>

                                                                                        {/* Case Description */}
                                                                                        <div className="admin-case-description">
                                                                                            <p
                                                                                                className="mb-2"
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: caseItem?.caseDetails?.clinicalhistory
                                                                                                }}
                                                                                            />
                                                                                            <p
                                                                                                className="quiz-para mb-3"
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: caseItem?.clinicalhistory
                                                                                                }}
                                                                                            />
                                                                                        </div>

                                                                                        {/* ANSWER SECTION */}
                                                                                        <div
                                                                                            className="admin-answer-box"
                                                                                        >
                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                    fact_check
                                                                                                </span>
                                                                                                <div className="fw-semibold admin-answer-heading">
                                                                                                    CASE ANSWER
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="correct admin-answer-text"
                                                                                            >
                                                                                                {caseItem?.answers?.[0]?.answer}
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* MARKS INPUT */}
                                                                                        <div className="row mb-3 align-items-center">
                                                                                            <div className="col-lg-6">
                                                                                                <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                    <span className="material-symbols-outlined icon-color">
                                                                                                        percent
                                                                                                    </span>
                                                                                                    <label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
                                                                                                        Marks <span style={{ color: "#dc3545" }}>*</span>
                                                                                                    </label>
                                                                                                </div>

                                                                                                <div className="col-4 admin-marks-input-wrapper">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className={`text-input ${errors[`${caseItem.caseid}_marks`] ? "border-danger" : ""
                                                                                                            }`}
                                                                                                        value={currentCaseData.marks}
                                                                                                        onChange={(e) =>
                                                                                                            handleMarksChange(caseItem.caseid, e.target.value)
                                                                                                        }
                                                                                                        style={{
                                                                                                            width: "100%",
                                                                                                            padding: "8px 30px 8px 10px",
                                                                                                            fontSize: "14px",
                                                                                                            borderRadius: "4px",
                                                                                                            border: errors[`${caseItem.caseid}_marks`]
                                                                                                                ? "2px solid #dc3545"
                                                                                                                : "1px solid #ced4da"
                                                                                                        }}
                                                                                                    />
                                                                                                    <span
                                                                                                        className="admin-marks-suffix"
                                                                                                    >
                                                                                                        %
                                                                                                    </span>
                                                                                                </div>

                                                                                                {errors[`${caseItem.caseid}_marks`] && (
                                                                                                    <small className="text-danger d-block mt-1" style={{ fontSize: "13px" }}>
                                                                                                        {errors[`${caseItem.caseid}_marks`]}
                                                                                                    </small>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* ANSWER SECTION */}
                                                                                        <div
                                                                                            className="admin-answer-box"
                                                                                        >
                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                    fact_check
                                                                                                </span>
                                                                                                <div className="fw-semibold admin-answer-heading">
                                                                                                    ACTUAl ANSWER
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="correct admin-answer-text"
                                                                                            >
                                                                                                {caseItem?.adminAnswer}
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* ADMIN REMARK (SAME FIELD, BETTER INTENT) */}
                                                                                        <div className="row">

                                                                                            <div className="col-12">
                                                                                                <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                    <span className="material-symbols-outlined icon-color">
                                                                                                        notes
                                                                                                    </span>
                                                                                                    <label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
                                                                                                        Explanation <span style={{ color: "#dc3545" }}>*</span>
                                                                                                    </label>
                                                                                                </div>
                                                                                                

                                                                                                <Editor
                                                                                                    value={currentCaseData?.summary ?? caseItem?.summary ?? ""}

                                                                                                     

                                                                                                    onChange={(e) => {
                                                                                                        console.log("Editor value:", e.target.value);
                                                                                                        handleSummaryChange(caseItem.caseid, e.target.value);
                                                                                                    }}
                                                                                                    style={{
                                                                                                        minHeight: "150px",
                                                                                                        border: errors[`${caseItem.caseid}_summary`]
                                                                                                            ? "2px solid #dc3545"
                                                                                                            : "1px solid #ced4da",
                                                                                                        borderRadius: "4px",
                                                                                                        fontSize: "14px"
                                                                                                    }}
                                                                                                    placeholder="Enter explanation here..."
                                                                                                />

                                                                                                {errors[`${caseItem.caseid}_summary`] && (
                                                                                                    <small className="text-danger d-block mt-1" style={{ fontSize: "13px" }}>
                                                                                                        {errors[`${caseItem.caseid}_summary`]}
                                                                                                    </small>
                                                                                                )}

                                                                                                {/* Character count */}
                                                                                                <small className="text-muted d-block mt-1" style={{ fontSize: "12px" }}>
                                                                                                    {stripHtmlTags(currentCaseData.summary).length} characters
                                                                                                </small>

                                                                                                {/* Saved content preview - Shows after save */}
                                                                                                {saveMessage && saveMessage.includes("Saved:") && (
                                                                                                    <div className="mt-3 p-3 bg-light border border-success rounded">
                                                                                                        <div className="d-flex align-items-center mb-2">
                                                                                                            <span className="material-symbols-outlined text-success me-2">
                                                                                                                check_circle
                                                                                                            </span>
                                                                                                            <strong className="text-success">{saveMessage.split(':')[0]}:</strong>
                                                                                                        </div>

                                                                                                        {/* Show the saved content preview */}
                                                                                                        <div className="saved-content-preview">
                                                                                                            <div
                                                                                                                dangerouslySetInnerHTML={{
                                                                                                                    __html: currentCaseData.summary || '<span className="text-muted">No content</span>'
                                                                                                                }}
                                                                                                                className="p-2 bg-white rounded border"
                                                                                                            />

                                                                                                            {/* Show plain text version too */}
                                                                                                            <div className="mt-2 text-muted" style={{ fontSize: "12px" }}>
                                                                                                                <strong>Plain text:</strong> {stripHtmlTags(currentCaseData.summary).substring(0, 100)}...
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* RIGHT IMAGE SECTION (STICKY) */}
                                                                                    <div
                                                                                        className="col-lg-4 quiz-img-section view-history-img-section"
                                                                                        style={{
                                                                                            position: "sticky",
                                                                                            alignSelf: "flex-start"
                                                                                        }}
                                                                                    >
                                                                                        <div className="quiz-img"></div>

                                                                                        <div
                                                                                            className={
                                                                                                caseItem?.caseDetails?.files?.length > 0
                                                                                                    ? "quiz_info content"
                                                                                                    : "quiz_info no-image content"
                                                                                            }
                                                                                        >
                                                                                            <div className="d-grid justify-content-start gap-2 align-items-center">

                                                                                                {/* Histology Images */}
                                                                                                <div className="img-wrapper">
                                                                                                    {caseItem?.caseDetails?.files?.length > 0 && (
                                                                                                        <p className="mt-2">Histological Photos</p>
                                                                                                    )}

                                                                                                    <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                        {caseItem?.caseDetails?.files?.map((file, fileIndex) => (
                                                                                                            <div
                                                                                                                key={fileIndex}
                                                                                                                className={`img me-2 ${!file?.thumbnailUrl ? "upload-static-img" : ""
                                                                                                                    }`}
                                                                                                                onClick={(e) => {
                                                                                                                    let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                                    let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                    //handlePopupImage(imagePath)
                                                                                                                    setPopupOpen(true);
                                                                                                                    setImageDimensions({ width: file.width, height: file.height });

                                                                                                                    let path = file.dziUrl || "";
                                                                                                                    if (path.startsWith("/")) path = path.slice(1);
                                                                                                                    let isDziURL = path.includes("output.dzi");
                                                                                                                    if (isDziURL) {
                                                                                                                        path = `${path}_files/`;
                                                                                                                        setDziUrl(imageCloudfront + path);
                                                                                                                    } else {
                                                                                                                        setDziUrl(imagePath);
                                                                                                                    }

                                                                                                                    setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                    setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                    handlePopupload(e);

                                                                                                                }}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view">
                                                                                                                    zoom_out_map
                                                                                                                </span>
                                                                                                                <span className="default-img">
                                                                                                                    <img
                                                                                                                        src={
                                                                                                                            file?.thumbnailUrl
                                                                                                                                ? imageCloudfront?.replace(/\/$/, "") +
                                                                                                                                file?.thumbnailUrl +
                                                                                                                                "?auto=compress,format&width=150"
                                                                                                                                : file?.sourcepath
                                                                                                                                    ? `${imageCloudfront}${file?.sourcepath.replace(
                                                                                                                                        / /g,
                                                                                                                                        "%20"
                                                                                                                                    )}?auto=compress,format`
                                                                                                                                    : deepZoom
                                                                                                                        }
                                                                                                                        alt={file?.originalFilename}
                                                                                                                    />
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </div>

                                                                                                {/* Clinical Images */}
                                                                                                <div className="img-wrapper">
                                                                                                    {caseItem?.caseDetails?.historyfiles?.length > 0 && (
                                                                                                        <p>Clinical History Photos</p>
                                                                                                    )}

                                                                                                    <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                        {caseItem?.caseDetails?.historyfiles?.map((file, key) => {
                                                                                                            let imagePath = `${imageCloudfront}${file?.sourcepath.replace(
                                                                                                                / /g,
                                                                                                                "%20"
                                                                                                            )}?auto=compress,format`

                                                                                                            return (
                                                                                                                <div
                                                                                                                    key={key}
                                                                                                                    className={`img me-2 ${!file?.thumbnailUrl ? "upload-static-img" : ""
                                                                                                                        }`}
                                                                                                                    style={{ width: "auto" }}
                                                                                                                    onClick={() => handlePngPopupImage(imagePath)}
                                                                                                                >
                                                                                                                    <span className="material-symbols-outlined img_view img-zoom">
                                                                                                                        zoom_out_map
                                                                                                                    </span>
                                                                                                                    <img
                                                                                                                        src={`${imageCloudfront}${file?.sourcepath.replace(
                                                                                                                            / /g,
                                                                                                                            "%20"
                                                                                                                        )}?auto=compress,format&width=125`}
                                                                                                                        alt={`Image ${key + 1}`}
                                                                                                                        loading="lazy"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            )
                                                                                                        })}
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className="cpcquiz-line"></div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    );
                                                                })}

                                                                {/* Single Submit and Reset Buttons at the Bottom */}
                                                                {/* <div className="btns quiz-form-btns">
                                                                    <button
                                                                        type="button"
                                                                        className="create-quiz-btn border-0 mr-10"
                                                                        onClick={handleSubmit}
                                                                        disabled={isSubmitting}
                                                                        style={{
                                                                            padding: "10px 24px",
                                                                            fontSize: "14px",
                                                                            fontWeight: "500",
                                                                            borderRadius: "4px",
                                                                            opacity: isSubmitting ? 0.6 : 1,
                                                                            cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                    >
                                                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="fw-normal outline_btn reset-quiz-btn mr-10"
                                                                        onClick={handleReset}
                                                                        disabled={isSubmitting}
                                                                    >
                                                                        Reset
                                                                    </button>

                                                                    {isSaved && (
                                                                        <span className="text-success d-flex align-items-center ms-3" style={{ fontSize: '14px', fontWeight: '500' }}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                                                            </svg>
                                                                            All cases saved successfully!
                                                                        </span>
                                                                    )}
                                                                </div> */}
                                                                {/* Single Save and Submit Buttons at the Bottom */}
                                                                <div className="btns quiz-form-btns">

                                                                    <button
                                                                        type="button"
                                                                        className="fw-normal outline_btn reset-quiz-btn mr-10"
                                                                        onClick={handleSave}
                                                                        disabled={isSubmitting}
                                                                        style={{
                                                                            opacity: isSubmitting ? 0.6 : 1,
                                                                            cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                    >
                                                                        {isSubmitting ? 'Saving...' : 'Save'}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="create-quiz-btn border-0 mr-10"
                                                                        onClick={handleSubmit}
                                                                        disabled={isSubmitting}
                                                                        style={{
                                                                            opacity: isSubmitting ? 0.6 : 1,
                                                                            cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                    >
                                                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                                                    </button>



                                                                    <button
                                                                        type="button"
                                                                        className="fw-normal outline_btn reset-quiz-btn mr-10"
                                                                        onClick={handleReset}
                                                                        disabled={isSubmitting}
                                                                    >
                                                                        Reset
                                                                    </button>

                                                                    {isSaved && (
                                                                        <span className="text-success d-flex align-items-center ms-3" style={{ fontSize: '14px', fontWeight: '500' }}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                                                            </svg>
                                                                            {saveMessage}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                X
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                {/* <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button> */}
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={popupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                    alt="Popup Image"
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ''} */}
                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button>
                                <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    {/* <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">X</span>
                                    </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            cursor: "pointer",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>

                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                    position: "absolute",
                                    bottom: "20px",
                                    left: "20px",
                                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                                    color: "white",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    fontSize: "12px"
                                }}>
                                    <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                    <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                    <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                    <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}




            {showImagePopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <img src={popupPngImage} className="modal-img" alt="Popup" />
                        {/* <button
                            onClick={() => setShowImagePopup(false)}
                            className="create-quiz-btn border-0"
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                cursor: "pointer",
                            }}
                        >
                            X
                        </button> */}
                        <button
                            className="dz_close"
                            onClick={() => setShowImagePopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                cursor: "pointer",
                                borderRadius: "6px",
                            }}
                        >
                            <span className="material-symbols-outlined">close</span>
                        </button>

                    </div>
                </div>
            )}
            {/* <Modal
                className="access-code-popup"
                show={activeFeedbackModal}
                backdrop="static"
                centered
                onHide={handleClosePopup}
            >
                <Modal.Header closeButton>
                    <Modal.Title> Feedback</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <div className="form-group feebback-box">
                            {feedbackLoading ? (
                                <>
                                    <div className="p-3 border rounded" style={{ minHeight: 160 }}>
                                        <div>Loading feedback...</div>
                                    </div>
                                    <small className="text-muted d-block mt-2">Fetching feedback mode...</small>
                                </>
                            ) : feedBackData?.status === "ARCHIVE" ? (
                                <>
                                    <p
                                        className="form-control feedback-textarea"
                                        style={{ minHeight: 160, whiteSpace: "pre-wrap", cursor: "default" }}
                                        aria-readonly="true"
                                    >
                                        {feedbackText || "No feedback available."}
                                    </p>
                                    <small className="text-muted d-block mt-2">
                                        This feedback has been reviewed.
                                    </small>
                                </>
                            ) : (
                                <>
                                    <textarea
                                        className="form-control feedback-textarea"
                                        rows="8"
                                        placeholder="Enter your feedback here..."
                                        value={feedbackText}
                                        onChange={handleFeedbackChange}
                                        autoFocus={!feedbackLoading}
                                    />
                                    {errorMsg && (
                                        <span className="errormsg text-danger fw-bold mt-1 d-block">
                                            {errorMsg}
                                        </span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer
                    className="d-flex justify-content-between modal-footer-custom"
                    style={{ width: "100%" }}
                >
                    {feedbackLoading ? (
                        <div className="w-100 d-flex justify-content-center">
                           
                        </div>
                    ) : feedBackData?.status === "ARCHIVE" ? (
                        <div className="w-100 d-flex justify-content-center">
                            
                        </div>
                    ) : (
                        <>
                            <button className="btn reset-quiz-btn" onClick={handleClosePopup} disabled={loading}>
                                Cancel
                            </button>

                            <button className="btn create-quiz-btn" onClick={handleFeedbackSubmit} disabled={loading}>
                                {loading ? "Submitting..." : (feedBackData ? "Update" : "Submit")}
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal> */}
            <Modal
                className="access-code-popup"
                show={activeFeedbackModal}
                backdrop="static"
                centered
                onHide={handleClosePopup}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Feedback</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <div className="form-group feebback-box">
                            {feedbackLoading ? (
                                // Loading skeleton / spinner while fetching
                                <>
                                    <div className="p-3 border rounded" style={{ minHeight: 160 }}>
                                        <div>Loading feedback...</div>
                                    </div>
                                    <small className="text-muted d-block mt-2">Fetching feedback mode...</small>
                                </>
                            ) : feedBackData?.status === "ARCHIVE" ? (
                                // Read-only display: render sanitized HTML markup
                                <>
                                    <div
                                        className="form-control feedback-textarea"
                                        style={{ minHeight: 160, cursor: "default", overflow: "auto" }}
                                        aria-readonly="true"
                                        // sanitized HTML injection
                                        dangerouslySetInnerHTML={{ __html: (feedbackText || feedBackData?.description || "No feedback available.") }}
                                    />
                                    <small className="text-muted d-block mt-2">This feedback has been reviewed.</small>
                                </>
                            ) : (
                                // Edit / Add using your rich HTML Editor
                                <>
                                    <div className="feedback-editor-wrapper">
                                        <Editor
                                            name="description"
                                            value={feedbackText}
                                            onChange={handleFeedbackChange}
                                            autoFocus={!feedbackLoading}
                                        />
                                    </div>

                                    {errorMsg && (
                                        <span className="errormsg text-danger fw-bold mt-1 d-block">
                                            {errorMsg}
                                        </span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer
                    className="d-flex justify-content-between modal-footer-custom"
                    style={{ width: "100%" }}
                >
                    {feedbackLoading ? (
                        // Disable actions while fetching
                        <div className="w-100 d-flex justify-content-center">
                            {/* Optionally show a spinner or disabled message */}
                        </div>
                    ) : feedBackData?.status === "ARCHIVE" ? (
                        // Archived: single Close button
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn reset-quiz-btn" onClick={handleClosePopup} disabled={loading}>
                                Close
                            </button>
                        </div>
                    ) : (
                        // Default: Cancel + Submit/Update
                        <>
                            <button className="btn reset-quiz-btn" onClick={handleClosePopup} disabled={loading}>
                                Cancel
                            </button>

                            <button className="btn create-quiz-btn" onClick={handleFeedbackSubmit} disabled={loading}>
                                {loading ? "Submitting..." : (feedBackData ? "Update" : "Submit")}
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            {showVideoPopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowVideoPopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <iframe
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                videoUrl
                            )}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video Preview"
                        ></iframe>
                        <button className="create-quiz-btn"
                            onClick={() => setShowVideoPopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            X
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};



export default AddSummary;  